import "./ArticlePage.scss"
import { useEffect, useState } from "react"
import { data, useParams } from "react-router-dom"
import Spinner from "../../components/Spinner/Spinner"
import ArticleSlide from "../../components/ArticleSlide/ArticleSlide";
import FadeIn from "../../components/FadeIn/FadeIn";
import { getDataByLink } from "../../service/service";
import { _baseImageUrl } from "../../service/constants";

const Section = ({ children }) => {
    const [ref, isVisible] = FadeIn(0.2);
    return (
      <section ref={ref} className={`fade-in-section ${isVisible ? "visible" : ""}`}>
        {children}
      </section>
    )
  }

const ArticlePage = () => {
    const [currArticle, setCurrArticle] = useState(null)
    const { link } = useParams()

    useEffect(() => {
        getDataByLink("blog", link).then((data) => {
            if(data && data.length){
                setCurrArticle(data[0])
            }else{ setCurrArticle(false)}
        }).catch(() => {
            setCurrArticle(false)
        })
    }, [link])

    const decodeHTML = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    


    return (
        <Section>
        <section className="full-article">
            <div className="container">
                {currArticle === null ? 
                    <Spinner className="no-padding" /> : !currArticle ?  <div>Not found!</div> : 
                    
                    <div className="full-article__wrapper">
                        <h1>{currArticle.title}</h1>
                        <div className="full-article__img">
                            <img src={_baseImageUrl + currArticle.image.path} alt={currArticle.title} />
                        </div>
                        <div className="full-article__descr"
                        dangerouslySetInnerHTML={{ __html: decodeHTML(currArticle.fullDescr) }}
                        />
                    </div>
                }
                     <ArticleSlide />
            </div>
        </section>
        </Section>
    )
}

export default ArticlePage